var _circle, _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _path, _mask5, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanetUranusInternal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 458,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 229,
    r: 229,
    fill: "#65F0D5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 458,
    height: 458
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 229,
    r: 229,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.12-150c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-156c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v156zm0 220c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12V-8h-.01c-.262-6.395-5.53-11.5-11.99-11.5S397.392-14.395 397.13-8h-.01v160c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-257c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v49c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12v-30c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12V70zm-96-205c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-73c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v73zm0 287c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12V79c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v73zm-12 264c6.628 0 12-5.373 12-12V238c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v166c0 6.627 5.373 12 12 12zm84-190c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-9c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v257c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12V274h.01c.262-6.395 5.53-11.5 11.99-11.5s11.728 5.105 11.99 11.5h.01v24c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12V142c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v84zm12 298c6.628 0 12-5.373 12-12V356c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v156c0 6.627 5.373 12 12 12z",
    fill: "#49CBC2"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 458,
    height: 458
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 229,
    r: 229,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.12-220c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12v-156c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v156zm0 220c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12v-78h.01c.262-6.395 5.53-11.5 11.99-11.5s11.728 5.105 11.99 11.5h.01V82c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12v-257c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v49c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-30c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12V0zm96-205c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12v-73c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v73zm0 287c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12V9c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v73zm12 264c-6.627 0-12-5.373-12-12V168c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v166c0 6.627-5.372 12-12 12zm-84-190c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12v-9c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v257c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12V204h-.01c-.262-6.395-5.53-11.5-11.99-11.5s-11.728 5.105-11.99 11.5h-.01v24c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12V72c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v84zm-12 298c-6.627 0-12-5.373-12-12V286c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v156c0 6.627-5.372 12-12 12z",
    fill: "#50DECD"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 458,
    height: 458
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 229,
    r: 229,
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.12-253c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-156c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v156zm0 220c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-78h-.01c-.262-6.395-5.53-11.5-11.99-11.5s-11.728 5.105-11.99 11.5h-.01V49c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-257c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v49c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12v-30c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v156zm-96-205c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-73c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v73zm0 287c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-73c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12v73zm-12 264c6.628 0 12-5.373 12-12V135c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v166c0 6.627 5.373 12 12 12zm84-190c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-9c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v257c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12V171h.01c.262-6.395 5.53-11.5 11.99-11.5s11.728 5.105 11.99 11.5h.01v24c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12V39c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v84zm12 298c6.628 0 12-5.373 12-12V253c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v156c0 6.627 5.373 12 12 12z",
    fill: "#77FFF5"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 458,
    height: 458
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 229,
    r: 229,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.078,
    fill: "#000",
    d: "M229 0h229v458H229z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229 450c122.055 0 221-98.945 221-221S351.055 8 229 8v442z",
    fill: "#138B83"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 8,
    width: 221,
    height: 442
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229 450c122.055 0 221-98.945 221-221S351.055 8 229 8v442z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 229,
    r: 145,
    fill: "#1BB9AE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 229.5,
    r: 32.5,
    fill: "#06504C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetUranusInternal);
export default __webpack_public_path__ + "static/media/planet-uranus-internal.578233c62999b0e1bec2f707bbeb999f.svg";
export { ForwardRef as ReactComponent };